/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { ManualActiveMedicationInput } from "./ManualActiveMedicationInput";

export interface SetActiveMedicationsRequest {
  medication_history_ids?: number[];
  manual_medications?: ManualActiveMedicationInput[];
}
